var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("new-ledger-account")))]),
      _c(
        "w-card-content",
        [
          _vm.tabs.length > 0
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-tabs", {
                        attrs: { tabs: _vm.tabs },
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tab == 0
            ? [
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("app-ledger-account-code-input", {
                          attrs: {
                            label: _vm.$ct("ledger-account-cols.code"),
                            fancy: "",
                            "has-error": _vm.codeFocused && !_vm.codeValid,
                          },
                          on: {
                            blur: function ($event) {
                              _vm.codeFocused = true
                            },
                          },
                          model: {
                            value: _vm.code,
                            callback: function ($$v) {
                              _vm.code = $$v
                            },
                            expression: "code",
                          },
                        }),
                        _vm.codeFocused &&
                        _vm.shownLedgerAccountCodeErrorMessage
                          ? _c("app-error-message-box", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.shownLedgerAccountCodeErrorMessage
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-input", {
                          attrs: {
                            label: _vm.$ct("ledger-account-cols.description"),
                            fancy: "",
                            "has-error":
                              _vm.descriptionFocused && !_vm.descriptionValid,
                          },
                          model: {
                            value: _vm.description,
                            callback: function ($$v) {
                              _vm.description = $$v
                            },
                            expression: "description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-select", {
                          attrs: {
                            items: _vm.balansItems,
                            label: _vm.$ct("ledger-account-cols.balans"),
                            fancy: "",
                          },
                          model: {
                            value: _vm.balans,
                            callback: function ($$v) {
                              _vm.balans = $$v
                            },
                            expression: "balans",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-select", {
                          attrs: {
                            items: _vm.typeItems,
                            label: _vm.$ct("ledger-account-cols.type"),
                            fancy: "",
                          },
                          model: {
                            value: _vm.ledgerType,
                            callback: function ($$v) {
                              _vm.ledgerType = $$v
                            },
                            expression: "ledgerType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-input-autocomplete", {
                          attrs: {
                            label: _vm.$ct("ledger-account-cols.group"),
                            fancy: "",
                            "has-error":
                              _vm.groupCodeFocused && !_vm.groupCodeValid,
                            items: _vm.groupCodeItems,
                            open: "",
                          },
                          on: {
                            "item-click": function ($event) {
                              return _vm.onGroupClick($event)
                            },
                            blur: function ($event) {
                              return _vm.onGroupBlur()
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _c("div", { staticClass: "code" }, [
                                        _vm._v(
                                          " " + _vm._s(scope.item.Code) + " "
                                        ),
                                      ]),
                                      _c("div", { staticClass: "name" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.item.Description) +
                                            " "
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2376827673
                          ),
                          model: {
                            value: _vm.groupCode,
                            callback: function ($$v) {
                              _vm.groupCode = $$v
                            },
                            expression: "groupCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("app-select-ledger-account-vat-field", {
                          attrs: {
                            label: _vm.$ct("ledger-account-cols.vat-field"),
                            fancy: "",
                          },
                          model: {
                            value: _vm.vatField,
                            callback: function ($$v) {
                              _vm.vatField = $$v
                            },
                            expression: "vatField",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.tab == 1
            ? _c("app-extra-fields-edit", {
                attrs: {
                  "name-settings": _vm.extraFieldNames,
                  value: _vm.extraFields,
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check", disabled: !_vm.isValid },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.create")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }